import React, { useEffect, useState } from "react";
import { StateProps } from "@tagged-state/core";
import { FaceTecDeviceSdkParamsContext, State } from "./state";

type Props = {
  children: React.ReactNode;
  getDeviceSdkParams: () => Promise<StateProps<State>["ready"]>;
};

const FaceTecDeviceSdkParamsInit: React.FC<Props> = (props) => {
  const { children, getDeviceSdkParams } = props;

  const [value, setValue] = useState<State>({ tag: "pending", data: {} });

  useEffect(() => {
    getDeviceSdkParams()
      .then((data) => {
        setValue({ tag: "ready", data });
      })
      .catch((error) => {
        setValue({ tag: "error", data: { error } });
      });
  }, [getDeviceSdkParams]);

  return (
    <FaceTecDeviceSdkParamsContext.Provider value={value}>
      {children}
    </FaceTecDeviceSdkParamsContext.Provider>
  );
};

export default FaceTecDeviceSdkParamsInit;
